import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface SidebarRowProps {
  className?: string;
  isHidden?: boolean;
  leftRowText: string;
  rightRowText?: string;
}

export const SidebarRow = (props: SidebarRowProps) => {
  if (props.isHidden) return null;
  return (
    <div className={cn('mb-5 flex justify-between', props.className)}>
      <Text className='pr-1' color={PaletteUtils.isVcfcPalette ? 'gray' : undefined} size='sm'>
        {props.leftRowText}
      </Text>
      {props.rightRowText && (
        <Text className='pl-1' weight='medium' size='sm' truncate>
          {props.rightRowText}
        </Text>
      )}
    </div>
  );
};
